import { Button, Card, CardBody, Chip, ModalBody, Modal, ModalHeader, ModalContent, ModalFooter, useDisclosure, Tab, Tabs, Spinner } from "@nextui-org/react"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  SELECTION_MODE,
} from "../../components/NextUITable.jsx"
import { calculateTotalByKey, selectFilter } from "../../Utility/utility.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { ENUM_DASHBOARD_COLOR, apiRoute } from "../../constants/enum.js"
import { ErrorCard, LoadingCard, NextUITable } from "../../components/index.js"
import DashboardSaleNPurchaseChart from "./DashboardSaleNPurchaseChart.jsx"

const filterTableFn = ({ data, columnNames, keyColumn, conditions }) => {

  let newData = data
  if (Object.values(conditions).join("")) {
    newData = selectFilter({ data: newData, conditions })
  }

  newData = calculateTotalByKey({
    data: newData,
    columnNames,
    keyColumn,
  })

  const updatedData = newData.map((ele) => {
    return { ...ele, NetRate: (ele.NetAmount / ele.Quantity).toFixed(2) }
  })
  return updatedData

}

function DashboardPurchase({ propDate, propUnit }) {
  const [data, setData] = useState([])

  const {
    isOpen: isOpenChartModel,
    onOpen: onOpenChartModel,
    onOpenChange: onOpenChartModelChange,
  } = useDisclosure();
  const { compCode, yearId } = useSelector((state) => state.company)
  // const { user } = useSelector((state) => state.auth)
  const [tableFilter, setTableFilter] = useState({
    "Purchase/Jobwork": "",
    mnth: "",
    party: "",
    item_desc: "",
  })
  const { mnth, party, item_desc } = tableFilter
  const {
    isPending,
    isError,
    data: purData = [],
    mutate: funLoadData
  } = usePost({
    url: apiRoute.dashboard.getMultiYearPurchaseData,
    queryKey: "DashboardPurchase",
    onSuccessTasks: (data) => {
      setData(data)
    }
  })
  useEffect(() => {
    funLoadData({
      data: {
        compcode: compCode.join(","),
        action: "OVERALL SUMMARY",
        db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
        fromdate: propDate.start,
        todate: propDate.end,
        lacid: propUnit || ''
      },
    })
  }, [propDate, propUnit])


  const columnNames = ["Quantity", "NetRate", "NetAmount"]

  const [selectedFilter, setSelectedFilter] = useState([])
  const [jobworkWiseData, setJobworkWiseData] = useState([])
  const [monthWiseData, setMonthWiseData] = useState([])
  const [partyWiseData, setPartyWiseData] = useState([])
  const [productWiseData, setProductWiseData] = useState([])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "Purchase/Jobwork",
      conditions: { mnth, party, item_desc },
    })
    setJobworkWiseData(newData)
  }, [data, mnth, party, item_desc])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "mnth",
      conditions: {
        "Purchase/Jobwork": tableFilter["Purchase/Jobwork"],
        party,
        item_desc,
      },
    })
    setMonthWiseData(newData)
  }, [data, tableFilter["Purchase/Jobwork"], party, item_desc])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "party",
      conditions: {
        "Purchase/Jobwork": tableFilter["Purchase/Jobwork"],
        mnth,
        item_desc,
      },
    })
    setPartyWiseData(newData)
  }, [data, tableFilter["Purchase/Jobwork"], mnth, item_desc])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "item_desc",
      conditions: {
        "Purchase/Jobwork": tableFilter["Purchase/Jobwork"],
        mnth,
        party,
      },
    })
    setProductWiseData(newData)
  }, [data, mnth, tableFilter["Purchase/Jobwork"], party])
  const handleChartData = (data) => {

  }
  useEffect(() => {
    handleChartData(monthWiseData)
  }, [data])
  let tables = [
    {
      columns: [
        {
          uid: "Purchase/Jobwork",
          name: "Purchase / Jobwork",
          sortable: true,
          textcolor: ENUM_DASHBOARD_COLOR.jobWork,
        },
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "Purchase/Jobwork",
        "NetAmount",
        "Quantity",
        "NetRate",
      ],
      downloadFileName: "Purchase_Data_Purchase_Jobwork",
      data: jobworkWiseData,
      id: "Purchase/Jobwork",
      // resetSelectedKeys: selectedKeysReset["Purchase/Jobwork"],
    },
    {
      columns: [
        {
          uid: "mnth",
          name: "month",
          sortable: true,
          textcolor: ENUM_DASHBOARD_COLOR.Month,
        },
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["mnth", "NetAmount", "Quantity", "NetRate"],
      downloadFileName: "Purchase_Data_Month",
      data: monthWiseData,
      id: "mnth",
      // resetSelectedKeys: selectedKeysReset["mnth"],
    },
    {
      columns: [
        { uid: "party", name: "Party Name", sortable: true, textcolor: ENUM_DASHBOARD_COLOR.Party }, // asked
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["party", "NetAmount", "Quantity", "NetRate"],
      downloadFileName: "Purchase_Data_Party",
      data: partyWiseData,
      id: "party",
      // resetSelectedKeys: selectedKeysReset["party"],
    },
    {
      columns: [
        { uid: "item_desc", name: "Item / Product", sortable: true, textcolor: ENUM_DASHBOARD_COLOR.Product },
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "item_desc",
        "NetAmount",
        "Quantity",
        "NetRate",
      ],
      downloadFileName: "Purchase_Data_Item_Product",
      data: productWiseData,
      id: "item_desc",
      resetSelectedKeys: false,
      // resetSelectedKeys: selectedKeysReset["item_desc"],
    },
  ]

  const topActionFilter = []

  const handleSelectionChange = ({ e, column }) => {
    if (e.size > 0) {
      let val = Array.from(e)[0]
      let newSelectedFilter = { key: column, value: val }

      if (!selectedFilter.find((obj) => obj.key === column)) {
        // column does not exist
        setSelectedFilter((prev) => [...prev, newSelectedFilter])
      } else {
        // column exist, but key changed
        setSelectedFilter((prev) =>
          prev.map((obj) => (obj.key === column ? newSelectedFilter : obj))
        )
      }

      setTableFilter((prev) => ({
        ...prev,
        [column]: val,
      }))
    } else {
      setSelectedFilter((prev) => prev.filter((item) => item.key !== column))
      setTableFilter((prev) => ({
        ...prev,
        [column]: "",
      }))
    }
  }


  const handleCloseSelectedFilter = (columnToRemove) => {
    setSelectedFilter(
      selectedFilter.filter((item) => item.key !== columnToRemove)
    )
    setTableFilter((prev) => ({
      ...prev,
      [columnToRemove]: "",
    }))

    if (selectedFilter.length === 1) {
      setSelectedFilter([])
    }
  }

  function SelectedFilter() {
    return (
      <div className="flex flex-wrap gap-2 mb-2">
        {selectedFilter.map((item, index) => (
          <Chip
            key={index}
            color="primary"
            variant="solid"
            size="sm"
            onClose={() => handleCloseSelectedFilter(item?.key)}
          >
            <div className="flex gap-2 items-center p-1">
              <span className="uppercase">{item?.key.replace("_", " ")}</span>
              <span className="bg-white text-primary p-0.5 rounded-md text-xs">
                {item?.value}
              </span>
            </div>
          </Chip>
        ))}
      </div>
    )
  }

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenChartModel}
          onOpenChange={onOpenChartModelChange}
          size="5xl"
          placement="center"
          scrollBehavior="inside"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex  border-2 border-b-rose-400  uppercase text-sky-700 font-bold text-sm">
                  Charts
                </ModalHeader>
                <ModalBody className="overflow-auto  p-5">

                </ModalBody>
                <ModalFooter>
                  <Button
                    color="danger"
                    className="bg-rose-400"
                    onPress={onClose}
                  >
                    Close
                  </Button>
                </ModalFooter>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    );
  };
  const handleChart = () => {
    onOpenChartModel();
  }
  // const
  return (
    <div>
      <SelectedFilter />
      {/* {isLoading && (
        <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
          <h2 className=" px-2" >Loading....</h2>
          <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
        </div>
      )} */}
      <div className="w-full">
        <Tabs aria-label="tabs" color="danger"  className="" variant="bordered" 
      
        >

          <Tab className="text-sm  " key="purchase" title="Data" >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2  p-0 m-0 ">
              {tables.map((table, index) => {
                return (
                  <Card key={index}>
                    <CardBody>
                      <NextUITable
                        INITIAL_VISIBLE_COLUMNS={table.INITIAL_VISIBLE_COLUMNS}
                        data={table.data}
                        columns={table.columns}
                        downloadFileName={table.downloadFileName}
                        id={table.id}
                        rowSelection={true}
                        selectionMode={SELECTION_MODE.single}
                        showTopContent={false}

                        topActionFilter={topActionFilter}
                        showPagination={false}
                        showFooter={false}
                        handleSelectionChange={handleSelectionChange}
                      />
                    </CardBody>
                  </Card>
                )
              })}
            </div>
          </Tab>
          <Tab className="text-sm" key="chart" title="Charts" >

            <DashboardSaleNPurchaseChart isSaleChart={false} dataFilter={selectedFilter} dataMonth={monthWiseData} dataJobWork={jobworkWiseData} dataParty={partyWiseData} dataProduct={productWiseData} />

          </Tab>

        </Tabs >
      </div>
      {/* selected filter chip */}
      {/* table */}

      {/* end of table */}

    </div >
  )
}
export default DashboardPurchase
